<template>
  <div class="card">
    <div class="card-content">
      <div class="col-md-8">
        <form>
          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Company"
                placeholder="Company name"
                v-model="user.company"
              ></fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="VAT Number"
                placeholder="VAT number"
                v-model="user.vat_number"
              ></fg-input>
            </div>
            <div class="col-md-4">
              <fg-input type="email" label="Email" placeholder="Email" v-model="user.email"></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input
                type="text"
                label="First Name"
                placeholder="First Name"
                v-model="user.first_name"
              ></fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Last Name"
                placeholder="Last Name"
                v-model="user.last_name"
              ></fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="SMS Notification number"
                placeholder="SMS Notification number (leave empty to disable)"
                v-model="user.notification_phone_number"
              ></fg-input>
              <small><i>Leave empty to disable SMS notifications - make sure to add country code! example: +0112345678</i></small>
            </div>
          </div>

          <div class="row">
            <div class="col-md-12">
              <fg-input
                type="text"
                label="Address"
                placeholder="Home Address"
                v-model="user.address_1"
              ></fg-input>
            </div>
          </div>

          <div class="row">
            <div class="col-md-4">
              <fg-input type="text" label="City" placeholder="City" v-model="user.city"></fg-input>
            </div>
            <div class="col-md-4">
              <fg-input type="text" label="Country" placeholder="Country" v-model="user.country"></fg-input>
            </div>
            <div class="col-md-4">
              <fg-input
                type="text"
                label="Postal Code"
                placeholder="ZIP Code"
                v-model="user.zipcode"
              ></fg-input>
            </div>
          </div>
          <div class="text-center">
            <button
              type="submit"
              class="btn btn-info btn-fill btn-wd"
              @click.prevent="updateProfile"
            ><i class="fas fa-save"></i> Update Profile</button>
          </div>

          <div class="clearfix"></div><br/><br/>
        </form>
      </div>
      <div class="col-md-4">
        <h4 class="title">Add or change avatar / company logo</h4>
        <vue-dropzone
          ref="uploadAvatar"
          id="dropzone"
          :options="dropzoneOptions"
          v-on:vdropzone-success="uploadSuccess"
          style="font-family: 'Roboto', Arial, Verdana; "
        ></vue-dropzone>
      </div>
    </div>
    <div class="clearfix"></div>
  </div>
</template>
<script>
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  data() {
    return {
      user: {
        company: "",
        first_name: "",
        email: "",
        last_name: "",
        address: "",
        city: "",
        postalCode: "",
        about: ""
      },
      dropzoneOptions: {
        paramName: "avatar",
        url: APIURL + "/profile/avatar",
        maxNumberOfFiles: 1,
        uploadMultiple: false,
        parallelUploads: 1,
        thumbnailWidth: 250,
        maxFilesize: 2,
        timeout: 180000,
        dictDefaultMessage:
          "<h1><i class='fa fa-cloud-upload-alt fa-2x'></i></h1><h3>Upload avatar/logo image here (max 2MB)</h3>",
        headers: { Authorization: "Bearer " + Ls.get("access_key"), 'CTR-Access-Key': SITEKEY }
      }
    };
  },
  methods: {
    updateProfile() {
      Webservice.updateProfile(this.user).then(resp => {
        if(resp.data == 'success') {
          this.$notify({
            component: {
              template: `<h5>Profile updated!</h5>`
            },
            icon: "fas fa-check",
            type: "success"
          });
          Webservice.getAvatar();
        } else {
          this.$notify({
            component: {
              template: `<h5>Something went wrong!</h5>Could not update profile :(`
            },
            icon: "fas fa-warn",
            type: "error"
          });
        }
      });
    },
    uploadSuccess(file, response) {
      if (response) {
        this.uploadData.files = response;
        this.$notify({
          component: {
            template: "<span>Avatar uploaded!</span>"
          },
          icon: "fas fa-check",
          type: "success"
        });      
      }
    }
  },
  mounted() {
    this.user = Webservice.getUser().then(response => {
      if (response.data) {
        this.user = response.data;
      }
    });
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/UserProfile/EditProfileForm.vue